import React from 'react';
import NoSSR from 'react-no-ssr';
import Chip from 'Chip';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import AreaStaticChip from '@ifeng-fe/container_content/common/client/components/areaStaticChip';

/**
 * 定义 Logo 组件
 */
class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        chipObj: PropTypes.object,
        logoAd: PropTypes.string,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { logo, domain, breadCrumbdata },
            chipObj,
            logoAd,
        } = this.props;

        return (
            <div className={styles.logo}>
                <a href={`//${domain}`} target="_blank">
                    <img src={logo.logo} alt={logo.title} />
                </a>
                <div className={styles.breadcrumbs}>
                    {breadCrumbdata.slice(1).map((item, index) => (
                        <span key={index}>
                            <a href={item.url}>{item.title}</a>
                            {' > '}
                        </span>
                    ))}
                    <span>正文</span>
                </div>
                <NoSSR>
                    <Chip
                        id={chipObj.logoAd}
                        type="static"
                        title="logoAd"
                        groupName="头部"
                        translate="handleAreaAd"
                        content={logoAd}>
                        <AreaStaticChip styleName={styles.logo_box} />
                    </Chip>
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(Logo);
